<template>
    <div>
        <vs-card>
            <h4 class="card-title d-flex">
                <span style="font-weight: bolder; font-size: xx-large">Statistiques</span><span> CEX</span>
            </h4>
            <div class="card-body">
                <vs-row vs-w="12">
                    <vs-col vs-type="flex"
                            vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                        <router-link
                            to="/statistics/cex/request-realtime-period">
                            <vs-card actionable class="cardx" fixedHeight>
                                <div slot="header">
                                    <h4>
                                        Requêtes à temps réel par période
                                    </h4>
                                </div>
                            </vs-card>
                        </router-link>
                    </vs-col>
                    <vs-col vs-type="flex"
                            vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                        <router-link
                            to="/statistics/cex/agent-with-realtime">
                            <vs-card actionable class="cardx" fixedHeight>
                                <div slot="header">
                                    <h4>
                                        Agents à temps réel par période
                                    </h4>
                                </div>
                            </vs-card>
                        </router-link>
                    </vs-col>
                    <vs-col vs-type="flex"
                            vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                        <router-link
                            to="/statistics/cex/plainte-period">
                            <vs-card actionable class="cardx" fixedHeight>
                                <div slot="header">
                                    <h4>
                                        Total plaintes par période
                                    </h4>
                                </div>
                            </vs-card>
                        </router-link>
                    </vs-col>
                    <vs-col vs-type="flex"
                            vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                        <router-link
                            to="/statistics/cex/request-call-reason-period">
                            <vs-card actionable class="cardx" fixedHeight>
                                <div slot="header">
                                    <h4>
                                        Call reason par période
                                    </h4>
                                </div>
                            </vs-card>
                        </router-link>
                    </vs-col>
                </vs-row>

                <vs-row vs-w="12">
                    <vs-col vs-type="flex"
                            vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                        <router-link
                            to="/statistics/cex/sla-category-period">
                            <vs-card actionable class="cardx" fixedHeight>
                                <div slot="header">
                                    <h4>
                                        Sla par catégorie et par période
                                    </h4>
                                </div>
                            </vs-card>
                        </router-link>
                    </vs-col>
                    <vs-col vs-type="flex"
                            vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                        <router-link
                            to="/statistics/cex/approbation">
                            <vs-card actionable class="cardx" fixedHeight>
                                <div slot="header">
                                    <h4>
                                        Approbation par période (Manager)
                                    </h4>
                                </div>
                            </vs-card>
                        </router-link>
                    </vs-col>
                    <vs-col vs-type="flex"
                            vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
                        <router-link
                            to="/statistics/cex/request-canal">
                            <vs-card actionable class="cardx" fixedHeight>
                                <div slot="header">
                                    <h4>
                                        Plainte par canal et par période
                                    </h4>
                                </div>
                            </vs-card>
                        </router-link>
                    </vs-col>
                </vs-row>
            </div>
        </vs-card>
    </div>
</template>

<script>
    export default {
        name: "ebu"
    }
</script>

<style scoped>
    h4 {
        height: 60px;
    }
    .con-vs-card.fixedHeight {
        width: 210px;
    }
</style>